// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"select_fieldset__mBQr8","select":"select_select__gb_Q1"};